import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { fetchTermsException } from "../../../../../services/termsExceptions";
import { ShowTermsException } from "./-components/ShowTermsException";

const RouteComponent: FC = () => {
  const termsException = Route.useLoaderData();

  return <ShowTermsException termsException={termsException} />;
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/",
)({
  component: RouteComponent,
  loader: ({ params: { termExceptionId } }) =>
    fetchTermsException(termExceptionId),
});
